/**
 * Fasen voor de dunne fasebalk. Pure functies.
 *
 * Eerlijk afvinken: een fase is pas 'klaar' als hij klaar is én alle aangezette fasen ervóór
 * ook (zelfde regel als de vorige flow-weergave). De huidige fase is:
 *  1. een fase die de PL zelf op 'bezig' zette (Fase wijzigen) — de laatste als het er meer zijn;
 *  2. anders de eerste fase die bezig is;
 *  3. anders de eerste die nog niet klaar is;
 *  4. anders de laatste.
 */

export function eerlijk(phases = []) {
  let allesKlaarTotNu = true;
  return (phases || []).map((p) => {
    if (!p.is_enabled) return p;
    if (p.status !== 'klaar') { allesKlaarTotNu = false; return p; }
    if (allesKlaarTotNu) return p;
    return { ...p, status: 'todo', deels: true };
  });
}

export function zichtbareFasen(phases = []) {
  return eerlijk(phases).filter((p) => p.is_enabled);
}

export function huidigeFase(phases = []) {
  const z = zichtbareFasen(phases);
  if (!z.length) return null;
  const handmatig = z.filter((p) => p.status_override === 'bezig');
  if (handmatig.length) return handmatig[handmatig.length - 1];
  return z.find((p) => p.status === 'bezig') || z.find((p) => p.status !== 'klaar') || z[z.length - 1];
}

/**
 * Segmenten voor de balk: { id, phase_key, label, stand: 'klaar' | 'nu' | 'later', uitleg }.
 * `uitleg` = de status in één zin (eerste bewijs), voor de tooltip.
 */
export function faseSegmenten(phases = []) {
  const z = zichtbareFasen(phases);
  const nu = huidigeFase(phases);
  return z.map((p) => {
    const stand = nu && p.phase_key === nu.phase_key ? 'nu' : p.status === 'klaar' ? 'klaar' : 'later';
    const bewijs = (p.evidence || []).filter(Boolean);
    const status = p.deels ? 'deels' : ({ klaar: 'klaar', bezig: 'bezig', todo: 'nog niet' }[p.status] || 'nog niet');
    const uitleg = [`${p.label}: ${status}${p.status_override ? ' (handmatig)' : ''}`, ...bewijs.slice(0, 2)].join(' — ');
    return { id: p.id, phase_key: p.phase_key, label: p.label, stand, uitleg, override: p.status_override || '' };
  });
}

/**
 * Wat "Fase wijzigen" naar de engine stuurt: de gekozen fase handmatig op 'bezig', en een
 * eerdere handmatige 'bezig' op een andere fase weer op automatisch. Lijst van
 * { id, status_override } (leeg = automatisch).
 */
export function faseWijzigingen(phases = [], gekozenKey) {
  const uit = [];
  (phases || []).forEach((p) => {
    if (p.phase_key === gekozenKey) {
      if (p.status_override !== 'bezig') uit.push({ id: p.id, status_override: 'bezig' });
    } else if (p.status_override === 'bezig') {
      uit.push({ id: p.id, status_override: '' });
    }
  });
  return uit;
}

/** De handmatige stand van álle fasen: Map(id → override, '' = automatisch). */
export function momentopname(phases = []) {
  return new Map((phases || []).map((p) => [p.id, p.status_override || '']));
}

/**
 * Wat er terug moet om een eerdere stand te herstellen, gerekend tegen de VERSE fasen: zo laat
 * ook een latere wijziging (Y → Z) geen tweede 'bezig' achter. Lijst van { id, status_override }.
 */
export function herstelVerschil(versePhases = [], stand = new Map()) {
  return (versePhases || [])
    .filter((p) => stand.has(p.id) && (p.status_override || '') !== stand.get(p.id))
    .map((p) => ({ id: p.id, status_override: stand.get(p.id) }));
}
